import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper';

const BannerTwo = () => {
    const [searchType, setSearchType] = useState('Landlord');

    const heroAnimationStyles = `
        @keyframes subtleZoom {
            0% { transform: scale(1); }
            100% { transform: scale(1.05); }
        }
        .hero-bg-anim {
            animation: subtleZoom 20s ease-in-out infinite alternate;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
        }
        .hero-swiper-container {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
        }
        .hero-swiper-container .swiper {
            width: 100%;
            height: 100%;
        }
    `;

    return (
        <section style={{ position: 'relative', minHeight: '85vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a3d62', overflow: 'hidden' }}>
            <style>{heroAnimationStyles}</style>
            
            <div className="hero-swiper-container">
                <Swiper
                    speed={2000}
                    effect={'fade'}
                    fadeEffect={{ crossFade: true }}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    modules={[Autoplay, EffectFade]}
                >
                    <SwiperSlide>
                        <div className="hero-bg-anim" style={{ backgroundImage: 'url(assets/images/banner/banner-6.jpg)' }}></div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="hero-bg-anim" style={{ backgroundImage: 'url(assets/images/banner/banner-5.jpg)' }}></div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="hero-bg-anim" style={{ backgroundImage: 'url(assets/images/banner/banner-7.jpg)' }}></div>
                    </SwiperSlide>
                </Swiper>
            </div>

            <div style={{
                position: 'absolute',
                top: 0, left: 0, width: '100%', height: '100%',
                background: 'linear-gradient(to right, rgba(10, 61, 98, 0.95), rgba(10, 61, 98, 0.3))',
                zIndex: 1,
                pointerEvents: 'none'
            }}></div>

            <div className="auto-container" style={{ width: '100%', zIndex: 2, position: 'relative', textAlign: 'left', padding: '50px 0' }}>
                <div style={{ maxWidth: '800px' }}>
                    <h1 style={{ color: '#ffffff', fontSize: 'clamp(3rem, 6vw, 4.5rem)', fontWeight: '300', marginBottom: '20px', lineHeight: 1.1 }}>
                        The search is over <br/>
                        <strong style={{ fontWeight: '700' }}>for your new Lettings Agent</strong>
                    </h1>
                    <p style={{ color: '#f6f5f0', fontSize: '1.25rem', marginBottom: '50px', fontWeight: '400', maxWidth: '600px', opacity: 0.9 }}>
                        Expert management for landlords. Clean, reliable homes for tenants. Experience property services built on trust and transparency.
                    </p>

                    <div style={{ maxWidth: '700px', margin: '0', textAlign: 'left' }}>
                        <div style={{ display: 'flex', gap: '2px', marginBottom: '0' }}>
                            <button 
                                onClick={() => setSearchType('Landlord')}
                                style={{
                                    padding: '15px 35px', 
                                    background: searchType === 'Landlord' ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255,255,255,0.15)', 
                                    color: searchType === 'Landlord' ? '#0a3d62' : '#ffffff',
                                    border: 'none',
                                    fontWeight: '700',
                                    borderRadius: '8px 8px 0 0',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    fontSize: '1rem',
                                    backdropFilter: searchType === 'Landlord' ? 'blur(10px)' : 'none'
                                }}
                            >
                                I'm a Landlord
                            </button>
                            <button 
                                onClick={() => setSearchType('Tenant')}
                                style={{
                                    padding: '15px 35px', 
                                    background: searchType === 'Tenant' ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255,255,255,0.15)', 
                                    color: searchType === 'Tenant' ? '#0a3d62' : '#ffffff',
                                    border: 'none',
                                    fontWeight: '700',
                                    borderRadius: '8px 8px 0 0',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    fontSize: '1rem',
                                    backdropFilter: searchType === 'Tenant' ? 'blur(10px)' : 'none'
                                }}
                            >
                                I'm a Tenant
                            </button>
                        </div>
                        <div style={{ 
                            display: 'flex', 
                            background: 'rgba(255, 255, 255, 0.95)', 
                            backdropFilter: 'blur(10px)',
                            padding: '10px', 
                            borderRadius: '0 8px 8px 8px', 
                            boxShadow: '0 20px 40px rgba(0,0,0,0.2)', 
                            flexWrap: 'wrap', 
                            gap: '10px' 
                        }}>
                            <input 
                                type="text" 
                                placeholder={searchType === 'Landlord' ? "Enter property postcode for valuation..." : "Search cities, postcodes or locations..."} 
                                style={{ flex: 1, padding: '15px 20px', border: 'none', outline: 'none', fontSize: '1.1rem', background: 'rgba(246, 245, 240, 0.8)', borderRadius: '4px', minWidth: '250px' }} 
                            />
                            <button 
                                style={{ background: '#25b579', color: '#ffffff', border: 'none', padding: '15px 40px', fontWeight: '700', borderRadius: '4px', fontSize: '1.1rem', cursor: 'pointer', transition: 'all 0.3s', whiteSpace: 'nowrap' }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = '#1e9b67';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 5px 15px rgba(37, 181, 121, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = '#25b579';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                }}
                                onClick={() => window.location.href = '/contact'}
                            >
                                {searchType === 'Landlord' ? "Get Valuation" : "Search Properties"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerTwo;
